import React from "react";
import { withAppState } from "../../state";
import { withFocusable } from "../../services/visualLibraryService";
import {
  HeaderStyled,
  ImageStyled,
  MainMenuContainerStyled,
  LogoWrapperStyled,
  LogoShadeStyled
} from "./styles/Styled";
import Logo from "../../components/Logo";
import { getLogger } from "../../utils/logger";
import { findFromBrands } from "../../helpers/find";
import { directions, i18n } from "../../services/i18nService";
import { getPath } from "../../utils/getPath";
import packageJson from "../../../package.json";

const appVersionQueryParameter = `?version=${packageJson?.version}`;

const MainMenuContainerFocus = withFocusable(MainMenuContainerStyled);

let slider;

export const defaultFocusPath = "mainMenu";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMenu: false,
      loaded: false,
      menuExpanded: false
    };
    //console.log('Header  props' ,props );
    this.handleFocusMenu = this.handleFocusMenu.bind(this);
    this.handleToggleMenu = this.handleToggleMenu.bind(this);
    this.navigate = this.navigate.bind(this);
    this.logger = getLogger();
    this.brandName = null;
    this.imageUrlSubscription = "";
    this.imageUrlBrands = "";
  }

  componentDidUpdate() {
    let isBrand = window.location.pathname.indexOf("brands/");
    const names = isBrand && window.location.pathname.split("/");
    if (isBrand) {
      this.brandName = names[2];
      let subscription = findFromBrands(this.brandName, this.props.applicationState.subscriptions || []);
      let baseSubscription = findFromBrands(this.brandName, subscription?.brands);
      this.imageUrlSubscription =
        subscription?.displayName === "STARZPLAY"
          ? `${baseSubscription?.configuration.logoDefaultPNG}`
          : `${subscription?.configuration.logoDefaultPNG}${appVersionQueryParameter}`;
    } else {
      this.brandName = null;
    }
  }

  handleFocusMenu(focused) {
    this.setState({ activeMenu: focused });
  }

  navigate() {
    slider.navigate();
    slider.rightMenuHandler();
    this.handleToggleMenu(false);
  }

  up() {
    slider.left();
  }

  down() {
    slider.right();
  }
  left() {
    slider.left();
  }

  right() {
    slider.rightMenuHandler();
   // slider.right();
  }
  handleToggleMenu(focused) {
    this.setState({ menuExpanded: focused });
  }

  render() {
    return (
      <>
        <LogoShadeStyled></LogoShadeStyled>
        <LogoWrapperStyled brandName={this.brandName}>
          {!this.brandName ? <Logo height={"8.055vh"} width={"15.47vw"} /> : <ImageStyled src={this.imageUrlSubscription} alt={this.brandName} />}
        </LogoWrapperStyled>
        {!this.brandName && (
          <HeaderStyled className={"isActiveMenu"}>
            {/* this was before <HeaderStyled className={this.state.activeMenu && "isActiveMenu"}>*/}
            <React.Fragment>
              <MainMenuContainerFocus
                focusPath={defaultFocusPath}
                handleFocus={this.handleFocusMenu}
                onRef={ref => (slider = ref)}
                onLeft={i18n.getDirection() !== directions.LEFT_TO_RIGHT ? this.right : () => {}}
                onRight={i18n.getDirection() === directions.LEFT_TO_RIGHT ? this.right : () => {}}
                onDown={this.down}
                onUp={this.up}
                onEnterPress={this.navigate}
                handleToggleMenu={this.handleToggleMenu}
                menuExpanded={this.state.menuExpanded}
              />
            </React.Fragment>
          </HeaderStyled>
        )}
      </>
    );
  }
}

Header.defaultFocusPath = defaultFocusPath;

export default withAppState(Header);
